import { initContract } from '@ts-rest/core';
import { Config } from '@retro-ui/config';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/config';

const ConfigSchema = c.type<Config['global']>();

export const configContract = c.router(
  {
    fetchConfig: {
      method: 'GET',
      path: '',
      responses: {
        200: ConfigSchema,
      },
    },
    fetchVisitorToken: {
      method: 'POST',
      path: '/visitor-token',
      body: z.object({ email: z.string() }),
      responses: {
        200: z.string(),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
